import { crashTimeline } from '@/mocks/gossipContent';
import Reveal from '@/components/base/Reveal';

const STATE_STYLE: Record<string, string> = {
  '发酵中': 'text-accent-700 bg-accent-100',
  '已回应': 'text-primary-700 bg-primary-100',
  '已反转': 'text-foreground-700 bg-foreground-100',
  '冷处理': 'text-secondary-800 bg-secondary-200',
};

export default function CrashSection() {
  return (
    <section id="crash" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* 左栏导语（吸附） */}
          <Reveal className="lg:col-span-4">
            <div className="lg:sticky lg:top-20">
              <div className="flex items-center gap-2 text-xs">
                <span className="font-heading text-accent-700 tracking-widest">CH.03</span>
                <span className="h-px w-8 bg-background-300" />
                <span className="text-foreground-500">翻车现场 · 时间轴</span>
              </div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold mt-3 tracking-tight">
                翻车现场
                <br />
                <span className="text-accent-700">实录档案</span>
              </h2>
              <p className="mt-4 text-sm text-foreground-700 leading-relaxed">
                按事件时间轴记录每一次“翻车”，并实时标注处理状态。从发生到回应、再到反转或冷处理，一档到底，不漏一环。
              </p>

              <div className="mt-6 rounded-md bg-background-50 border border-background-200/70 p-4">
                <div className="flex items-center gap-2 text-sm font-medium">
                  <i className="ri-information-line text-accent-700 w-5 h-5 flex items-center justify-center" />
                  状态图例
                </div>
                <div className="mt-3 flex flex-wrap gap-2">
                  {Object.keys(STATE_STYLE).map((s) => (
                    <span key={s} className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 text-xs ${STATE_STYLE[s]}`}>
                      {s}
                    </span>
                  ))}
                </div>
                <p className="mt-3 text-xs text-foreground-600 leading-relaxed">
                  当事方给出可信回应或证据后，状态即更新，并在下方补一条更正记录。
                </p>
              </div>

              <a
                href="#archive"
                className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 text-foreground-950 px-4 py-2.5 text-sm font-medium hover:bg-accent-600 transition-colors"
              >
                去翻塌房合集档案
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </a>
            </div>
          </Reveal>

          {/* 右栏时间轴 */}
          <div className="lg:col-span-8">
            <div className="relative pl-6 md:pl-8">
              <span className="absolute left-2 md:left-3 top-1 bottom-1 w-px bg-background-300" aria-hidden="true" />
              <div className="space-y-4">
                {crashTimeline.map((it, idx) => (
                  <Reveal key={it.id} delay={idx * 50}>
                    <article className="relative">
                      <span className="absolute -left-6 md:-left-8 top-5 flex h-3 w-3 -translate-x-1/2 items-center justify-center rounded-full border-2 border-background-50 bg-accent-500" aria-hidden="true" />
                      <div className="group rounded-md bg-background-50 border border-background-200/70 p-4 md:p-5 hover:border-accent-300 transition-colors">
                        <div className="flex flex-wrap items-center gap-2 text-xs">
                          <span className="inline-flex items-center gap-1 font-medium text-accent-700">
                            <i className="ri-time-line w-4 h-4 flex items-center justify-center" />
                            {it.date}
                          </span>
                          <span className="text-background-300">·</span>
                          <span className="text-foreground-500">{it.actor}</span>
                          <span className="text-background-300">·</span>
                          <span className="text-foreground-500">{it.refs}</span>
                          <span className={`ml-auto inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-medium ${STATE_STYLE[it.state]}`}>
                            {it.state}
                          </span>
                        </div>
                        <h3 className="font-heading text-lg font-semibold leading-snug mt-2.5">
                          <a href="#featured" className="group-hover:text-accent-700 transition-colors">
                            {it.title}
                          </a>
                        </h3>
                        <p className="mt-1.5 text-sm text-foreground-700 leading-relaxed">{it.summary}</p>
                      </div>
                    </article>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}